import React from 'react';
import { Button, Text, Modal, Icon, Box } from '../design-system';
import { upperFirst } from 'lodash';

interface ModalDeleteProps {
  entity: string;
  open: boolean;
  onCancel: () => void;
  onDelete: () => void;
}

const ModalDelete = ({
  entity,
  open,
  onCancel,
  onDelete,
}: ModalDeleteProps) => {
  return (
    <Modal open={open} onClose={onCancel}>
      <Modal.Header>
        <Text color="danger" fontSize={18}>
          <Box mr={2} display="inline">
            <Icon name="alert" color="danger" />
          </Box>
          Delete {upperFirst(entity)}
        </Text>
      </Modal.Header>
      <Modal.Body>
        <Text>Are you sure you want to delete this {entity}?</Text>
        <Button.Group mt={4} justifyContent="space-between">
          <Button
            aria-label="Cancel"
            variant="grey"
            type="button"
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button
            id="actual-delete-button"
            aria-label="Confirm Delete"
            type="button"
            variant="danger"
            onClick={onDelete}
          >
            Delete
          </Button>
        </Button.Group>
      </Modal.Body>
    </Modal>
  );
};

export default ModalDelete;
